import { render } from "./CourseRevitationNavigation.vue?vue&type=template&id=53ce54a9&scoped=true"
import script from "./CourseRevitationNavigation.vue?vue&type=script&lang=js"
export * from "./CourseRevitationNavigation.vue?vue&type=script&lang=js"

import "./CourseRevitationNavigation.vue?vue&type=style&index=0&id=53ce54a9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ce54a9"]])

export default __exports__